import { Trans } from "@lingui/macro";
import { UiBox, UiTypography } from "@smp/ui";

export const PageNotFound = () => (
  <UiBox
    alignItems="center"
    display="flex"
    flexDirection="column"
    height="100%"
    justifyContent="center"
    width="100%"
  >
    <UiTypography gutterBottom variant="h1">
      404
    </UiTypography>
    <UiTypography>
      <Trans>Sorry, we can't find this page.</Trans>
    </UiTypography>
  </UiBox>
);
